import React, { useEffect, useRef, useState, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../_common/AlertModal";
import { useSelector } from "react-redux";

function AdrTentativeAgreementDisputeModalV3(props) {
  const { showModal, toggleModal, data } = props;

  const user = useSelector((state) => state.authentication.user || null);

  const [showAlert_formIncomplete, _setShowAlert_formIncomplete] = useState(false);
  const toggleAlert_formIncomplete = () =>
    _setShowAlert_formIncomplete(!showAlert_formIncomplete);

  const [fieldsForDispute, setFieldsForDispute] = useState({
    name: data.name || (data.disputedBy === "ct" && user ? user.fullName : ""),
    remarks: data.remarks || "",
  });

  const [formErrors, setFormErrors] = useState({ name: null });

  useEffect(() => validateForm(), [fieldsForDispute]);

  const validateForm = () => {
    let _formErrors = { ...formErrors };

    if (!fieldsForDispute.name) _formErrors = { ..._formErrors, name: "Required" };
    else _formErrors = { ..._formErrors, name: null };

    setFormErrors(_formErrors);
  };

  const formIsIncomplete = () => Object.values(formErrors).some((e) => e);

  const handleClick_ok = (e) => {
    e.preventDefault();

    if (formIsIncomplete()) toggleAlert_formIncomplete();
    else {
      data.applyDispute(fieldsForDispute);
      toggleModal();
    }
  };

  const handleChange = (e) =>
    setFieldsForDispute({ ...fieldsForDispute, [e.target.name]: e.target.value });

  const handleBlur = () => validateForm();

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={showModal} size="md">
      <ModalHeader className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="file-signature" className="fa-fw mr-2" />
        Dispute Tentative Agreement
      </ModalHeader>
      <ModalBody>
        <div className="card">
          <div className="card-body p-3">
            <h5 className="text-muted">
              {data.disputedBy === "ct" ? "Caltrans Rep." : "Contractor"}
            </h5>
            <div className="form-row form-group my-2">
              <label htmlFor="name" className="col-form-label col-3">
                <b>Name:</b>*
              </label>
              <div className="col-9">
                <input
                  id="name"
                  name="name"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={fieldsForDispute.name}
                />
                {formErrors.name && (
                  <span className="error-small">
                    <small>{formErrors.name}</small>
                  </span>
                )}
              </div>
            </div>
            <div className="form-row form-group mb-0">
              <label htmlFor="remarks" className="col-form-label col-3">
                Remarks:
              </label>
              <div className="col-9">
                <input
                  id="remarks"
                  name="remarks"
                  maxLength={30}
                  className="form-control"
                  onChange={handleChange}
                  value={fieldsForDispute.remarks}
                />
                <span className="text-small">
                  {`${(fieldsForDispute.remarks || "").length}/30 characters`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group">
          <button
            id="taSignCancel"
            name="taSignCancel"
            className="btn btn-secondary mx-2"
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button
            id="taSignOk"
            name="taSignOk"
            className="btn btn-primary"
            onClick={handleClick_ok}
            disabled={formIsIncomplete()}
          >
            OK
          </button>
        </div>
      </ModalFooter>
      {showAlert_formIncomplete && (
        <AlertModal
          alertKey="taFormIncompleteAlert"
          alertTitle="Form Incomplete"
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText={`Required fields are not completed. Sign/dispute status will not be updated until all required fields are completed.\nDo you wish to exit?`}
          acceptCaption={"Yes"}
          acceptClass={"danger"}
          provideReject={true}
          rejectCaption={"No"}
          rejectClass={"secondary"}
          handleAlertAction={handleAlert_formIncomplete}
          showAlertModal={showAlert_formIncomplete}
          toggleAlertModal={toggleAlert_formIncomplete}
        />
      )}
    </Modal>
  );
}

export default AdrTentativeAgreementDisputeModalV3;
